var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7302 21.9211C9.47331 21.8839 7.08258 18.3835 7.08258 15.6722C7.08258 12.2832 9.73403 9.5116 11.5017 9.5116C13.4726 9.5116 13.9057 11.7354 13.9057 11.7354M2.00063 12.0186C2.00063 8.63416 5.4652 6.73536 8.12991 6.73536C10.7946 6.73536 13.9322 8.95449 13.9322 12.0186C13.9322 13.5042 13.0837 13.3045 13.0837 14.1959C13.0837 14.8876 14.4094 15.3565 15.8942 15.3565C18.2982 15.3565 21.1971 14.0938 20.9894 10.9972C20.8048 9.07266 20.0928 7.24567 18.9398 5.73763C17.7868 4.22959 16.2422 3.10522 14.4932 2.50078C12.7442 1.89634 10.8659 1.83776 9.08582 2.33215C7.30578 2.82654 5.70042 3.85267 4.46427 5.2862C3.22813 6.71974 2.41426 8.49914 2.12128 10.4088C1.82831 12.3184 2.06881 14.2764 2.81363 16.0453C3.55846 17.8143 4.77564 19.3184 6.31769 20.3753C7.85974 21.4322 9.66047 21.9965 11.5017 22C15.0369 22 17.9712 19.8691 19.7742 16.9675C20.0659 16.5032 19.5488 16.039 19.0848 16.4661C15 20 8.5 17.5 9.13746 12.2043C9.13746 10.4355 10.1097 9.94335 10.1097 9.94335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.a4bc4e0b47ec820afa10471585a8790d.svg";
export { ForwardRef as ReactComponent };